export default "__VITE_ASSET__Drvy_TUA__"